export default __webpack_public_path__ + "static/media/swiper1.a97ea0bb.png";